import { lazyNamed } from 'src/utils/lazyNamed';

export const Placement = {
  List: lazyNamed(() => import('./containers/PlacementsList'), 'PlacementsList'),
  Edit: lazyNamed(() => import('./containers/PlacementEdit'), 'PlacementEditPage'),
  History: lazyNamed(() => import('./containers/PlacementHistory'), 'PlacementHistory'),
};
